export default __webpack_public_path__ + "static/media/compass.e1d74a25.png";